"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.placeWebOrder = placeWebOrder;
exports.confirmWebPayment = confirmWebPayment;
exports.orderLicense = orderLicense;
exports.confirmPage = confirmPage;
exports.formPage = formPage;
exports.getDriverLicenses = getDriverLicenses;
exports.getAllDriversByProject = getAllDriversByProject;
exports.checkDriverLicenseCount = checkDriverLicenseCount;
exports.getInvitationByToken = getInvitationByToken;
exports.grantDriverLicense = grantDriverLicense;
exports.sendDriverLicenseInvitation = sendDriverLicenseInvitation;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORDER_LICENSE = "maaporssi/license/ORDER_LICENSE";
var ORDER_LICENSE_FAIL = "maaporssi/license/ORDER_LICENSE_FAIL";
var ORDER_LICENSE_SUCCESS = "maaporssi/license/ORDER_LICENSE_SUCCESS";

var GET_DRIVER_LICENSES = "maaporssi/license/GET_DRIVER_LICENSES";
var GET_DRIVER_LICENSES_FAIL = "maaporssi/license/GET_DRIVER_LICENSES_FAIL";
var GET_DRIVER_LICENSES_SUCCESS = "maaporssi/license/GET_DRIVER_LICENSES_SUCCESS";

var GET_ALL_DRIVER_LICENSES = "maaporssi/license/GET_ALL_DRIVER_LICENSES";
var GET_ALL_DRIVER_LICENSES_FAIL = "maaporssi/license/GET_ALL_DRIVER_LICENSES_FAIL";
var GET_ALL_DRIVER_LICENSES_SUCCESS = "maaporssi/license/GET_ALL_DRIVER_LICENSES_SUCCESS";

var SEND_DRIVER_LICENSE_INVITATION = "maaporssi/license/SEND_DRIVER_LICENSE_INVITATION";
var SEND_DRIVER_LICENSE_INVITATION_FAIL = "maaporssi/license/SEND_DRIVER_LICENSE_INVITATION_FAIL";
var SEND_DRIVER_LICENSE_INVITATION_SUCCESS = "maaporssi/license/SEND_DRIVER_LICENSE_INVITATION_SUCCESS";

var OPEN_CONFIRM_PAGE = "maaporssi/license/OPEN_CONFIRM_PAGE";
var CLOSE_CONFIRM_PAGE = "maaporssi/license/CLOSE_CONFIRM_PAGE";

var CREATE_WEB_ORDER = "maaporssi/license/CREATE_WEB_ORDER";
var CREATE_WEB_ORDER_SUCCESS = "maaporssi/license/CREATE_WEB_ORDER_SUCCESS";
var CREATE_WEB_ORDER_FAIL = "maaporssi/license/CREATE_WEB_ORDER_FAIL";

var CHECK_DRIVER_LICENSE_ORDER = "maaporssi/license/CHECK_DRIVER_LICENSE_ORDER";
var CHECK_DRIVER_LICENSE_ORDER_SUCCESS = "maaporssi/license/CHECK_DRIVER_LICENSE_ORDER_SUCCESS";
var CHECK_DRIVER_LICENSE_ORDER_FAIL = "maaporssi/license/CHECK_DRIVER_LICENSE_ORDER_FAIL";

var GET_INVITATION_BY_TOKEN = "maaporssi/license/GET_INVITATION_BY_TOKEN";
var GET_INVITATION_BY_TOKEN_SUCCESS = "maaporssi/license/GET_INVITATION_BY_TOKEN_SUCCESS";
var GET_INVITATION_BY_TOKEN_FAIL = "maaporssi/license/GET_INVITATION_BY_TOKEN_FAIL";

var GRANT_DRIVER_LICENSE_ORDER = "maaporssi/license/GRANT_DRIVER_LICENSE_ORDER";
var GRANT_DRIVER_LICENSE_ORDER_SUCCESS = "maaporssi/license/GRANT_DRIVER_LICENSE_ORDER_SUCCESS";
var GRANT_DRIVER_LICENSE_ORDER_FAIL = "maaporssi/license/GRANT_DRIVER_LICENSE_ORDER_FAIL";

var CONFIRM_WEB_PAYMENT = "maaporssi/license/CONFIRM_WEB_PAYMENT";
var CONFIRM_WEB_PAYMENT_SUCCESS = "maaporssi/license/CONFIRM_WEB_PAYMENT_SUCCESS";
var CONFIRM_WEB_PAYMENT_FAIL = "maaporssi/license/CONFIRM_WEB_PAYMENT_FAIL";

var initialState = {
  orderLicenseLoading: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ORDER_LICENSE:
      return (0, _extends3.default)({}, state, {
        orderLicenseLoading: true
      });
    case ORDER_LICENSE_FAIL:
      return (0, _extends3.default)({}, state, {
        orderLicenseLoading: false,
        orderLicenseError: action.error.error
      });
    case ORDER_LICENSE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        orderLicenseLoading: false,
        orderLicenseSuccess: true
      });
    case GET_DRIVER_LICENSES:
      return (0, _extends3.default)({}, state, {
        getDriverLicensesLoading: true
      });
    case GET_DRIVER_LICENSES_FAIL:
      return (0, _extends3.default)({}, state, {
        getDriverLicensesLoading: false,
        getDriverLicensesError: action.error.error
      });
    case GET_DRIVER_LICENSES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        driverLicenses: action.result,
        getDriverLicensesLoading: false,
        getDriverLicensesSuccess: true
      });
    case GET_ALL_DRIVER_LICENSES:
      return (0, _extends3.default)({}, state, {
        getAllDriverLicensesLoading: true
      });
    case GET_ALL_DRIVER_LICENSES_FAIL:
      return (0, _extends3.default)({}, state, {
        getAllDriverLicensesLoading: false,
        getAllDriverLicensesError: action.error.error
      });
    case GET_ALL_DRIVER_LICENSES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        allDriverLicenses: action.result,
        getAllDriverLicensesLoading: false,
        getAllDriverLicensesSuccess: true
      });
    case SEND_DRIVER_LICENSE_INVITATION:
      return (0, _extends3.default)({}, state, {
        sendDriverLicensesLoading: true
      });
    case SEND_DRIVER_LICENSE_INVITATION_FAIL:
      return (0, _extends3.default)({}, state, {
        sendDriverLicensesLoading: false,
        sendDriverLicensesError: action.error.error
      });
    case SEND_DRIVER_LICENSE_INVITATION_SUCCESS:
      return (0, _extends3.default)({}, state, {
        driverLicenseInvitation: action.result,
        sendDriverLicensesLoading: false,
        sendDriverLicensesSuccess: true
      });
    case OPEN_CONFIRM_PAGE:
      return (0, _extends3.default)({}, state, {
        confirmPage: true
      });
    case CLOSE_CONFIRM_PAGE:
      return (0, _extends3.default)({}, state, {
        confirmPage: false
      });
    case CREATE_WEB_ORDER:
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: true
      });
    case CREATE_WEB_ORDER_FAIL:
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: false,
        placeOrderError: action.error.error || "ERROR"
      });
    case CREATE_WEB_ORDER_SUCCESS:
      if (action.result.status === "PENDING_PAYMENT" && action.result.payment_url) {
        window.location = action.result.payment_url;
        return (0, _extends3.default)({}, state, {
          createWebOrderSuccess: true
        });
      };
    case CHECK_DRIVER_LICENSE_ORDER:
      return (0, _extends3.default)({}, state, {
        checkDriverLicenseLoading: true
      });
    case CHECK_DRIVER_LICENSE_ORDER_FAIL:
      return (0, _extends3.default)({}, state, {
        checkDriverLicenseLoading: false,
        checkDriverLicenseError: action.error.error || "ERROR"
      });
    case CHECK_DRIVER_LICENSE_ORDER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        availableTokens: action.result,
        checkDriverLicenseSuccess: true
      });
    case GET_INVITATION_BY_TOKEN:
      return (0, _extends3.default)({}, state, {
        getInvitatioByTokenLoading: true
      });
    case GET_INVITATION_BY_TOKEN_FAIL:
      return (0, _extends3.default)({}, state, {
        getInvitatioByTokenLoading: false,
        getInvitatioByTokenError: action.error.error || "ERROR"
      });
    case GET_INVITATION_BY_TOKEN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        invitation: action.result,
        getInvitatioByTokenSuccess: true
      });

    case GRANT_DRIVER_LICENSE_ORDER:
      return (0, _extends3.default)({}, state, {
        grantDriverLicenseLoading: true
      });
    case GRANT_DRIVER_LICENSE_ORDER_FAIL:
      return (0, _extends3.default)({}, state, {
        grantDriverLicenseLoading: false,
        grantDriverLicenseError: action.error.error || "ERROR"
      });
    case GRANT_DRIVER_LICENSE_ORDER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        grantDriverLicenseSuccess: true
      });

    case CONFIRM_WEB_PAYMENT:
      return (0, _extends3.default)({}, state, {
        confirmWebPaymentLoading: true
      });
    case CONFIRM_WEB_PAYMENT_FAIL:
      return (0, _extends3.default)({}, state, {
        confirmWebPaymentLoading: false,
        confirmWebPaymentError: action.error.error

      });
    case CONFIRM_WEB_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        confirmWebPaymentLoading: false,
        confirmWebPaymentSuccess: true
      });
    default:
      return state;
  }
}

function placeWebOrder(formData) {
  // console.info('placeWebOrder : formData',formData);

  return {
    types: [CREATE_WEB_ORDER, CREATE_WEB_ORDER_SUCCESS, CREATE_WEB_ORDER_FAIL],
    promise: function promise(client) {
      return client.post("/user_license_orders", {
        data: formData
      });
    }
  };
}

function confirmWebPayment(orderId, params) {
  // console.info('confirmWebPayment : params',params);
  return {
    types: [CONFIRM_WEB_PAYMENT, CONFIRM_WEB_PAYMENT_SUCCESS, CONFIRM_WEB_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post("/user_license_orders/" + orderId + "/confirm", {
        data: params
      });
    }
  };
}

// this creates new user licence into user_license
function orderLicense(userId, paymentType, formData) {
  // console.info('orderLicense : params',formData);

  return {
    types: [ORDER_LICENSE, ORDER_LICENSE_SUCCESS, ORDER_LICENSE_FAIL],
    promise: function promise(client) {
      return client.put("/users/" + userId, { data: formData }).then(function () {
        client.post("/users/" + userId + "/" + paymentType + "/licenses");
      });
    }
  };
}

function confirmPage() {
  return {
    type: OPEN_CONFIRM_PAGE
  };
}

function formPage() {
  return {
    type: CLOSE_CONFIRM_PAGE
  };
}
// DRIVER LICENSES


function getDriverLicenses(companyId) {
  return {
    types: [GET_DRIVER_LICENSES, GET_DRIVER_LICENSES_SUCCESS, GET_DRIVER_LICENSES_FAIL],
    promise: function promise(client) {
      return client.get("/get_driver_licenses/" + companyId);
    }
  };
}

function getAllDriversByProject(companyIdList) {
  return {
    types: [GET_ALL_DRIVER_LICENSES, GET_ALL_DRIVER_LICENSES_SUCCESS, GET_ALL_DRIVER_LICENSES_FAIL],
    promise: function promise(client) {
      return client.post("get_all_driver_licenses", {
        data: companyIdList
      });
    }
  };
}

function checkDriverLicenseCount(driverLicenseToken) {
  return {
    types: [CHECK_DRIVER_LICENSE_ORDER, CHECK_DRIVER_LICENSE_ORDER_SUCCESS, CHECK_DRIVER_LICENSE_ORDER_FAIL],
    //  promise: (client) => client.get(`/check_driver_license_count/${driverLicenseToken}`)
    promise: function promise(client) {
      return client.get("/check_driver_license_count/" + driverLicenseToken);
    }
  };
}

function getInvitationByToken(token) {
  return {
    types: [GET_INVITATION_BY_TOKEN, GET_INVITATION_BY_TOKEN_SUCCESS, GET_INVITATION_BY_TOKEN_FAIL],
    //  promise: (client) => client.get(`/check_driver_license_count/${driverLicenseToken}`)
    promise: function promise(client) {
      return client.get("/get_invitation_by_token/" + token);
    }
  };
}

// get_invitation_by_token

function grantDriverLicense(formData) {
  return {
    types: [GRANT_DRIVER_LICENSE_ORDER, GRANT_DRIVER_LICENSE_ORDER_SUCCESS, GRANT_DRIVER_LICENSE_ORDER_FAIL],
    promise: function promise(client) {
      return client.post("/driver_licenses/grant", {
        data: formData
      });
    }
  };
}
function sendDriverLicenseInvitation(data) {
  return {
    types: [SEND_DRIVER_LICENSE_INVITATION, SEND_DRIVER_LICENSE_INVITATION_SUCCESS, SEND_DRIVER_LICENSE_INVITATION_FAIL],
    promise: function promise(client) {
      return client.post("/driver_license_invitation", {
        data: data
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/license.js
 ** module id = 111
 ** module chunks = 0
 **/